import { getConfig } from '@superbet-group/web.lib.config';
import { persistState } from '@superbet-group/web.lib.vue-utilities';
import { BetSlipPurchaseType } from '@superbet-group/web.types';
import { Store } from 'vuex';

import StoreUtil from '@app/store/StoreUtil';
import { SerializedBetSlip } from '@core/models/betSlip/serialization/ISerializedBetSlip';
import ISelection from '@models/betSlip/ISelection';
import { IState } from '@src/app/store';
import { BetSlipState } from '@store/modules/ui/betSlip/types';

const BETSLIP_STORAGE_KEY = 'multiBetSlip';
const INITIALIZE_BETSLIP = 'ui/sportOffer/betSlip/getSelectionsFromStorage';

const BET_SLIP_REGEX = /^ui\/sportOffer\/betSlip\/*/;

function extractState(state: IState) {
    return state.ui.sportOffer.betSlip as BetSlipState;
}

export default (store: Store<IState>): IState => {
    let deserializedState: ReturnType<typeof deserializeState> | null;
    return persistState<any>({
        key: BETSLIP_STORAGE_KEY,
        filter: (mutation) => isBetSlipMutation(mutation.type),
        reducer: (state: IState) => serializeBetSlip(extractState(state)),
        getState(_key: string, storage: Storage) {
            deserializedState = deserializeState(storage, BETSLIP_STORAGE_KEY);
            if (deserializedState && Object.keys(deserializedState).length > 0) {
                const {
                    purchaseType,
                } = deserializedState as SerializedBetSlip;
                return {
                    ui: {
                        sportOffer: {
                            betSlip: {
                                purchaseType: getConfig().countrySpecific.corona.areShopsDisabled
                                    ? BetSlipPurchaseType.online : purchaseType,
                            },
                        },
                    },
                };
            }
            return {};
        },
        async rehydrated() {
            const instanceStates = deserializedState && (deserializedState as SerializedBetSlip).betSlips;
            if (instanceStates) {
                await Promise.all([
                    StoreUtil.createMutationSubscriptionPromise(store, 'data/country/SET_CONFIG'),
                    StoreUtil.createActionSubscriptionPromise(store, 'data/sportOffer/setIsOfferReady'),
                ]);
                await store.dispatch(INITIALIZE_BETSLIP, instanceStates);
            }
            // This needs to happen either way, because we need the flag for the
            // add to betslip from URL/promo to work
            await store.dispatch('navigation/setSportBetSlipRehydrated', true);
        },
    })(store);
};

const isBetSlipMutation = (mutationType: string): boolean => {
    return BET_SLIP_REGEX.test(mutationType);
};

function serializeBetSlip(state: BetSlipState): SerializedBetSlip {
    const { purchaseType } = state;

    const betSlip: SerializedBetSlip['betSlips'][0] = {
        selections: state.selections.map((s: ISelection) => s.serialize()),
        stake: state.stake!,
        selectedSystems: state.selectedSystems,
        type: state.type,
    };

    return {
        purchaseType,
        betSlips: [betSlip],
    };
}

function deserializeState(storage: Storage, key: string): SerializedBetSlip | Record<string, never> {
    try {
        return JSON.parse(storage.getItem(key)!) as SerializedBetSlip;
    } catch (e) {
        return {};
    }
}
